// Tool results in the transcript are pointers. This window event lets the
// Knowledge page and open cards reread live page proposals after the assistant
// creates one, without growing the shared workspace state.
const PAGES_CHANGED = 'poneva:knowledge-pages-changed';

function announce(name: string) {
  window.dispatchEvent(new Event(name));
}

function subscribe(name: string, listener: () => void) {
  window.addEventListener(name, listener);
  return () => window.removeEventListener(name, listener);
}

export const announceKnowledgePagesChanged = () => announce(PAGES_CHANGED);
export const subscribeKnowledgePagesChanged = (listener: () => void) =>
  subscribe(PAGES_CHANGED, listener);
